import { useState } from "react";
import { useParams } from "react-router";
import { Dialog, DialogContent, DialogTitle } from "@/lib/components/Dialog";
import { AnalyticsApi } from "@/lib/api/analytics-api";
import {
  useMarkTutorialOpenedMutation,
  useSelfQuery,
} from "@/lib/queries/user-queries";
import { Tutorial } from "./tutorials";

export function useOpenedTutorialIds() {
  const { data: self } = useSelfQuery();

  return (
    self && (self.flags.tutorials ?? []).map((tutorial) => tutorial.tutorialId)
  );
}

export function useTutorialVideoDialog() {
  const { teamExternalId } = useParams();
  const [tutorial, setTutorial] = useState<Tutorial | null>(null);
  const markTutorialOpened = useMarkTutorialOpenedMutation();

  const play = (tutorial: Tutorial) => {
    setTutorial(tutorial);
    AnalyticsApi.logTutorialClicked(teamExternalId, tutorial.id);
    markTutorialOpened.mutate(tutorial.id);
  };

  const dialog = (
    <Dialog
      open={!!tutorial}
      onOpenChange={(open) => !open && setTutorial(null)}
    >
      <DialogContent
        className="max-w-3xl overflow-hidden border-0 bg-black [&>[data-slot=dialog-close]]:z-10 [&>[data-slot=dialog-close]]:bg-black/50 [&>[data-slot=dialog-close]]:text-white [&>[data-slot=dialog-close]]:hover:bg-black/70 [&>[data-slot=dialog-close]]:hover:text-white"
        classNameInner="p-0 sm:p-0"
      >
        <DialogTitle className="sr-only">{tutorial?.title}</DialogTitle>
        {tutorial && (
          <iframe
            className="aspect-video w-full"
            src={`https://player.vimeo.com/video/${tutorial.vimeoId}?autoplay=1&badge=0&title=0&byline=0&portrait=0`}
            title={tutorial.title}
            allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share"
            referrerPolicy="strict-origin-when-cross-origin"
            allowFullScreen
          />
        )}
      </DialogContent>
    </Dialog>
  );

  return { play, dialog };
}
